module.exports = __webpack_public_path__ + "img/editIcon.d9c6b906.png";